import React, { Component } from 'react';
import { object } from 'prop-types';
import styled from 'styled-components';
import { map } from 'lodash';
import { Text } from '..';

const Table = styled.table`
    width: 100%;
    height: fit-content;
`;

export default class CustomTable extends Component {
    static propTypes = {
        data: object,
        columns: object
    }

    render () {
        const { data, columns } = this.props;
        return (
            <Table>
                <thead>
                    <tr>
                        { map(columns, ({ title, thStyle }, index) => <th key={index} style={thStyle}><Text text={title} strong /></th>) }
                    </tr>
                </thead>
                <tbody>
                    { map(data, (item, index) => <tr key={index}>{ map(columns, ({ dataIndex, render, tdStyle }, tdIndex) => <td key={tdIndex} style={tdStyle}>{ render(item[dataIndex], item) }</td>) }</tr>) }
                </tbody>
            </Table>
        );
    }
}
